import {mapValues} from 'es-toolkit'

import mediaQueriesJson from '../styles/media-queries.json'

export interface IBreakpoints {
  [name: string]: boolean
}

interface IMediaqueryDefinition {
  [name: string]: string
}

export const mediaQueries = mapValues(mediaQueriesJson as IMediaqueryDefinition, value =>
  value.replace(/'/g, '')
)

export const getBreakpoints = (): IBreakpoints => {
  const breakpoints = (Object.keys(mediaQueries) as [string]).reduce((acc, breakpoint) => {
    acc[breakpoint] = global.matchMedia(mediaQueries[breakpoint].replace(/'/g, '')).matches
    return acc
  }, {} as IBreakpoints)
  return breakpoints
}
